import { Stack } from 'react-bootstrap'
import { Field } from '@ztechapps/webui.form'
import { CompanySelect } from '@ztechapps/company.webui'
import { PhoneNumberInput } from '@ztechapps/webui.input'
import React from 'react'

export const VendorFormLayout = ({ disabledCompany }: { disabledCompany?: boolean }) => {
  return (
    <Stack gap={2}>
      <Field
        name="company"
        component={CompanySelect}
        label="Company"
        help="Update the company for this contact."
        onChange
        showInfo={true}
        disabled={disabledCompany}
      />
      <Field name="profile.name" label="Contact Name" help="Contact name" />
      <Field name="profile.email" label="Contact Email" help="Contact primary email" />
      <Field name="phone" component={PhoneNumberInput} label="Phone" help="Contact primary phone" />
    </Stack>
  )
}
